<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <custom-popup
          v-model="dialog"
          :cons="{ title: $t('image_gallery') }"
          max-width="500"
          id="gallery"
        >
          <v-card>
            <v-tabs color="deep-purple accent-4" light>
              <v-tab>{{ $t("all") }}</v-tab>
              <v-tab-item>
                <v-container fluid>
                  <v-row class="p-3">
                    <v-col
                      v-for="image in img"
                      :key="image.id"
                      cols="12"
                      class="p-0"
                      :class="
                        image.selected ? 'border border-2 border-success' : ''
                      "
                      md="4"
                      :data-img="image.id"
                      @click="select(image)"
                    >
                      <v-img
                        :src="image.full_path"
                        :lazy-src="image.full_path"
                        aspect-ratio="1"
                        :key="image.id"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab v-for="(category, i) in cats" :key="i">{{
                category
              }}</v-tab>
              <v-tab-item v-for="item in cats" :key="item" :data-id="item">
                <v-container fluid>
                  <v-row class="p-3">
                    <v-col
                      v-for="image in img.filter((im) => im.category === item)"
                      :key="image.id"
                      cols="12"
                      class="p-0"
                      :class="
                        image.selected ? 'border border-2 border-success' : ''
                      "
                      md="4"
                      :data-img="image.id"
                      @click="select(image)"
                    >
                      <v-img
                        :src="image.full_path"
                        :lazy-src="image.full_path"
                        aspect-ratio="1"
                        :key="image.id"
                      >
                      </v-img>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </custom-popup>

        <v-card-actions>
          <div class="rowinfo">
            <v-btn color="green lighten-3" class="flex" @click="dialog = true">
              <v-icon>mdi-image</v-icon>
              {{ $t("select_photo") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-selectedImage`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$('select_photo')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "picSelectorSingle",
  props: {
    value: {
      require: true,
      type: String,
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "picselectorsingle",
      dialog: false,
      img: [],
      cats: [],
      url: process.env.VUE_APP_ROBOT,
      manualImage: {
        link: "",
      },
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    img() {
      const categories = [];
      this.img.forEach((item, index) => {
        categories.push(item.category);

        this.img[index]["selected"] =
          this.selectedImage?.[item.category]?.indexOf(item.md5) > -1;
      });
      this.$data.cats = new Set([...categories]);
    },
  },
  methods: {
    select(image) {
      this.img.forEach((item) => (item.selected = false));

      image.selected = true;

      this.$emit("input", image.full_path);

      this.$forceUpdate();
    },
    getImages() {
      const vm = this;
      $.ajax({
        url: `${this.url}/files`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        type: "GET",
        success: function (data) {
          vm.img = data.data;
        },
      });
    },
  },
  mounted() {
    this.getImages();
  },
};
</script>

<style scoped></style>
